// import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import {checkIfInBlogCategory} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyAdditionalFunctions"
import BlogPosts from "@jsons/blogPosts.json"
import SocialData from "@jsons/socialResponsibility.json"
import SocialResponsibilityBlogSection from "@pages/SocialResponsibility/SocialResponsibilityBlog/SocialResponsibilityBlogSection"
import SocialResponsibilityBuildingSection from "@pages/SocialResponsibility/SocialResponsibilityBuilding/SocialResponsibilityBuildingSection"
import SocialResponsibilityContactFormSection from "@pages/SocialResponsibility/SocialResponsibilityForm/SocialResponsibilityContactFormSection"
import SocialResponsibilityIntroSection from "@pages/SocialResponsibility/SocialResponsibilityIntro/SocialResponsibilityIntroSection"
import React from "react"

type Props = {}

const community = (props: Props) => {
	const pageData = getTranslatedPageData(SocialData, true, true)
	const AdvancedSideAsset = getValueOrThrow(pageData.AdvancedSideAsset)

	const Posts = getPosts("BlogPostsModule", {data: BlogPosts})

	const checkCategory = () => {
		return checkIfInBlogCategory(Posts, ["community"])
	}

	return (
		<>
			<HeadMeta meta={pageData.metaData} />

			{/* <FullWidthHeader
				data={getValueOrThrow(AdvancedSideAsset?.[0].mainContent)[0]}
				position={"left"}
				size={"L"}
				withOverlay
			/> */}
			<FullWidthHeaderAdvanced
				data={getValueOrThrow(pageData.heroData)}
				withOverlay
			/>
			<SocialResponsibilityIntroSection data={AdvancedSideAsset[1]} />

			<SocialResponsibilityBuildingSection data={AdvancedSideAsset[2]} />

			<SocialResponsibilityBlogSection
				blogs={checkCategory()}
				data={AdvancedSideAsset[3]}
			/>

			<SocialResponsibilityContactFormSection
				data={AdvancedSideAsset[4]}
			/>
		</>
	)
}

export default community
